import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { useFieldContext } from '../field/context';
import { Element } from '../../atoms';
import * as styles from './toggle.styles';

/** @type {import(".").ToggleType} */
const Toggle = forwardRef(({ className, onChange, ...props }, ref) => {
  const fieldProps = useFieldContext({ onChange, ...props });

  const handleCheckboxOnClick = (evt) => {
    evt.stopPropagation();
  };

  return (
    <Element
      ref={ref}
      as="label"
      isInteractive
      withEnterAsClick
      className={clsx(styles.toggle, className, { disabled: fieldProps.disabled })}
      tabIndex={fieldProps.disabled ? -1 : 0}
      {...props}
    >
      <input
        className="hidden"
        type="checkbox"
        readOnly
        name={fieldProps.name}
        checked={fieldProps.checked}
        disabled={fieldProps.disabled}
        onChange={fieldProps.onChange}
        onClick={handleCheckboxOnClick}
      />
    </Element>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Toggle.displayName = 'Toggle';
}

export default Toggle;
